//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("./is-empty");

export function validateNewItemERPCode(data) {
  let validationErrors = {};

  data.newItemERPCode = !isEmpty(data.newItemERPCode)
    ? data.newItemERPCode
    : "";

  if (Validator.isEmpty(data.newItemERPCode)) {
    validationErrors.newItemERPCode = "New Item Code field is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
